import { FC, useContext, useMemo, memo } from 'react';
import { useTranslation } from 'react-i18next';
import styled, { ThemeContext } from 'styled-components';
import { Segment } from '~src/interfaces/segment.interface';

import AvatarBox from '~src/shared/avatarBox/AvatarBox';
import TooltipList from '~src/shared/tooltips/TooltipList';
import { getNameOfSegment } from '~src/services/getNameOfSegment';

const CmpContainer = styled.div`
  display: flex;
  align-items: center;
`;

const AvatarWrapper = styled.div<{ $zIndex: number }>`
  z-index: ${({ $zIndex }) => $zIndex};
`;

const RowBox = styled.div`
  display: flex;
  ${/*sc-custom*/ AvatarWrapper}:not(:first-child) {
    margin-left: -7px;
    position: relative;
  }
`;

const RestCount = styled.div`
  font-size: 0.8rem;
  color: ${({ theme }) => theme.baseBlue.a10};
  margin-left: 3px;
  font-weight: 600;
  cursor: default;
`;

interface OwnProps {
  userData: Segment[];
  avatarSize?: number;
  previewCount?: number;
}

type Props = OwnProps;

const AvatarsRow: FC<Props> = memo(props => {
  const [t] = useTranslation();
  const themeContext = useContext(ThemeContext);
  const { avatarSize = 24, previewCount = 4 } = props;
  const restCount = props.userData.length - previewCount;
  const namesArr = useMemo(() => {
    return props.userData.map(user => {
      return { id: user.id, name: getNameOfSegment(t, user) || '' };
    });
  }, [props.userData.length]);

  const getRestCountStr = (count: number) => (count > 999 ? `${Math.round(count / 1000)}k` : count);

  return (
    <CmpContainer>
      <RowBox>
        {props.userData.slice(0, previewCount).map((user, i) => (
          <AvatarWrapper key={user.id} $zIndex={props.userData.length - i}>
            <AvatarBox
              size={avatarSize}
              type={user.type}
              name={getNameOfSegment(t, user)}
              url={user.image_url}
              borderColor={themeContext.white.a10}
            />
          </AvatarWrapper>
        ))}
      </RowBox>
      {restCount > 0 && (
        <TooltipList
          items={namesArr}
          restCount={restCount}
          placement="bottom"
          overlayStyle={{ fontSize: '0.8rem' }}
        >
          <RestCount>+{getRestCountStr(props.userData.length - previewCount)}</RestCount>
        </TooltipList>
      )}
    </CmpContainer>
  );
});

export default AvatarsRow;
